import { render, staticRenderFns } from "./checkDeskTemplate.vue?vue&type=template&id=466c2f51&scoped=true&"
import script from "./checkDeskTemplate.vue?vue&type=script&lang=js&"
export * from "./checkDeskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./checkDeskTemplate.vue?vue&type=style&index=0&id=466c2f51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c2f51",
  null
  
)

export default component.exports